<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="添加专家" />
		<ExpertTeamFrom @eventForm="handleGetForm" />
	</div>
</template>

<script>
	import ExpertTeamFrom from '@/components/ExTeam/Form'
	export default {
		methods: {
			handleGetForm(form) {
				this.$axios.post('/Myseller-SellerManage-addZhuanjiaInfo',form).then(data => {
					if(data.code == 200){
						this.$message.success('添加成功');
						this.$router.push('/expertTeam')
					}else{
						this.$message.success(data.msg);
					}
				})
			}
		},
		components: {
			ExpertTeamFrom
		}
	}
</script>
